import { render, staticRenderFns } from "./umap_regular.vue?vue&type=template&id=16f64638&scoped=true&"
import script from "./umap_regular.vue?vue&type=script&lang=js&"
export * from "./umap_regular.vue?vue&type=script&lang=js&"
import style0 from "./umap_regular.vue?vue&type=style&index=0&id=16f64638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f64638",
  null
  
)

export default component.exports